import React, { useMemo, useCallback, useState, useEffect, useContext, Fragment } from 'react'
import { Flex, Box } from 'reflexbox'
import { ThemeContext } from 'styled-components'

import { ChevronRight, ChevronLeft } from 'components/Icons'
import { Text } from 'components/Typography'

import { PaginationButton } from './styles'

const Pagination = ({ paginationOptions, pagination, elementsPerPage }) => {
  const theme = useContext(ThemeContext)
  const [selectedPage, setSelectedPage] = useState(1)

  const handleNextPage = useCallback(
    () => selectedPage !== paginationOptions?.total_pages && setSelectedPage(selectedPage + 1),
    [selectedPage],
  )

  const handlePreviousPage = useCallback(() => selectedPage > 1 && setSelectedPage(selectedPage - 1), [selectedPage])

  const AvailablePages = useMemo(() => {
    if (paginationOptions?.total_pages <= 3)
      return Array.from({ length: paginationOptions?.total_pages }).map((_, i) => i + 1)

    return Array.from({ length: paginationOptions?.total_pages })
      .map((_, i) => i + 1)
      .slice(
        selectedPage === paginationOptions?.total_pages ? selectedPage - 3 : selectedPage < 2 ? 0 : selectedPage - 2,
        selectedPage === 1 ? selectedPage + 2 : selectedPage + 1,
      )
  }, [selectedPage, paginationOptions])

  useEffect(() => pagination && pagination({ page: selectedPage, limit: elementsPerPage }), [selectedPage])

  return (
    <Flex justifyContent='space-between' alignItems='center' mt={24}>
      <PaginationButton onClick={handlePreviousPage}>
        <ChevronLeft color={theme.colors.grays.N500} />
      </PaginationButton>
      <Flex>
        {paginationOptions && !AvailablePages.some(page => page <= 2) && (
          <Fragment>
            <PaginationButton onClick={() => setSelectedPage(1)}>
              <Text fontWeight={800} color={selectedPage === 1 ? theme.colors.blues.A800 : theme.colors.grays.N500}>
                1
              </Text>
            </PaginationButton>
            <Text fontWeight={800} color={theme.colors.grays.N500}>
              ...
            </Text>
          </Fragment>
        )}
        {AvailablePages.map((option, index) => (
          <PaginationButton onClick={() => setSelectedPage(option)} key={index}>
            <Text fontWeight={800} color={selectedPage === option ? theme.colors.blues.A800 : theme.colors.grays.N500}>
              {option}
            </Text>
          </PaginationButton>
        ))}
        {paginationOptions && !AvailablePages.includes(paginationOptions.total_pages) && (
          <Fragment>
            <Text fontWeight={800} color={theme.colors.grays.N500}>
              ...
            </Text>
            <PaginationButton onClick={() => setSelectedPage(paginationOptions.total_pages)}>
              <Text
                fontWeight={800}
                color={
                  selectedPage === paginationOptions.total_pages ? theme.colors.blues.A800 : theme.colors.grays.N500
                }
              >
                {paginationOptions.total_pages}
              </Text>
            </PaginationButton>
          </Fragment>
        )}
      </Flex>
      <PaginationButton onClick={handleNextPage}>
        <ChevronRight color={theme.colors.grays.N500} />
      </PaginationButton>
    </Flex>
  )
}

export default Pagination
